// extracted by mini-css-extract-plugin
module.exports = {"rightHeaderWrapper":"UqXTY5p5","positive":"UhtcAcz0","negative":"eLqf_HAJ","neutral":"c58Y3tlI","rightHeaderReturnLabel":"l5zJrxkJ","rightHeaderReturnValue":"MO5Q1IzJ"};